import React, { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { defineMessages, useIntl } from "react-intl";

import BillingContactUs from "@app/postBill/components/billingContactUs";
import BillingPaymentContainer from "@app/postBill/components/billingPaymentContainer";
import { BlueHeaderContent } from "@app/components/ui/layout";
import { routes } from "@app/routing";

import "./billingPayment.scss";

const messages = defineMessages({
  billingPaymentTitle: {
    id: "billingPaymentTitle",
    defaultMessage: "Make a payment",
  },
  billingPaymentSubtitle: {
    id: "billingPaymentSubtitle",
    defaultMessage:
      "Select the payment method you want to use. You can also use your FSA or HSA card.",
  },
});

const BillingPayment: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const { from, paymentPlanId } = location.state ?? {};

  const handleBack = (from: string) => {
    if (!location.state) {
      navigate(routes.reviewBills, {
        state: { from: routes.billingPayment },
      });
    } else if (paymentPlanId) {
      navigate(from, {
        state: { paymentPlanId },
      });
    } else {
      navigate(from);
    }
  };

  return (
    <BlueHeaderContent
      blueHeaderTitle={intl.formatMessage(messages.billingPaymentTitle)}
      backArrowHeaderButton={() => handleBack(from)}
      noGradient
    >
      <div className="billing-payment">
        <div className="billing-payment__content">
          <div className="billing-payment__subtitle">
            {intl.formatMessage(messages.billingPaymentSubtitle)}
          </div>
          <BillingPaymentContainer />
          <div className="review-bills__contact-us">
            <BillingContactUs />
          </div>
        </div>
      </div>
    </BlueHeaderContent>
  );
};

export default BillingPayment;
